/**
 * Rock Off Retail — prev/next arrow controls for a horizontal scroll-snap
 * slider (see sections/rockoff-product-slider.liquid). Touch swipe is left
 * completely alone — this only adds a second, keyboard/mouse-friendly way
 * to move the same native `overflow-x: auto` track.
 *
 * Buttons hide themselves whenever the track doesn't actually overflow
 * (nothing to scroll to), re-checked on load, resize, and content scroll.
 */
class RockoffArrowSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-slider]');
    this.prevBtn = this.querySelector('[data-slider-prev]');
    this.nextBtn = this.querySelector('[data-slider-next]');
    if (!this.track || !this.prevBtn || !this.nextBtn) return;

    this.prevBtn.addEventListener('click', () => this.scrollByPage(-1));
    this.nextBtn.addEventListener('click', () => this.scrollByPage(1));
    this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });

    this.resizeObserver = new ResizeObserver(() => this.updateOverflow());
    this.resizeObserver.observe(this.track);

    this.updateOverflow();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  scrollByPage(direction) {
    const card = this.track.querySelector(':scope > *');
    const step = card ? card.getBoundingClientRect().width + 22 : this.track.clientWidth * 0.8;
    this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
  }

  updateOverflow() {
    const hasOverflow = this.track.scrollWidth > this.track.clientWidth + 2;
    this.classList.toggle('ro-arrow-slider--has-overflow', hasOverflow);
    this.updateButtons();
  }

  updateButtons() {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    this.prevBtn.disabled = scrollLeft <= 1;
    this.nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
  }
}

customElements.define('rockoff-arrow-slider', RockoffArrowSlider);
